import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from './App';
import reportWebVitals from './reportWebVitals';
import BatchProvider from './context/BatchMgmtContext';
import CaseProvider from './context/CaseContext';
import DistributionCheckProvider from './context/DistributionCheckContext'
import GeneralLedgerProvider from './context/GeneralLedgerContext';
import PaymentPlanProvider from './context/PaymentPlanContext';
import SearchProvider from './context/SearchContext';
import SystemProvider from './context/SystemContext'
import { UserProvider } from './context/UserContext';

import { LicenseInfo } from '@mui/x-license';
import { CcComponent } from './components/modals/components/paymentsTab/CcComponent';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
const firstMUIPremuimLicense = process.env.REACT_APP_MUI_PREMIUM_LICENSE_1;
const secondMUIPremiumLicense = process.env.REACT_APP_MUI_PREMIUM_LICENSE_2;

LicenseInfo.setLicenseKey(firstMUIPremuimLicense, secondMUIPremiumLicense);

root.render(
    <BrowserRouter basename={baseUrl}>
        <UserProvider>
            <SystemProvider>
                <CaseProvider>
                    <SearchProvider>
                        <BatchProvider>
                            <GeneralLedgerProvider>
                                <DistributionCheckProvider>
                                    <PaymentPlanProvider>
                                        <CcComponent>
                                            <App />
                                        </CcComponent>
                                    </PaymentPlanProvider>
                                </DistributionCheckProvider>
                            </GeneralLedgerProvider>
                        </BatchProvider>
                    </SearchProvider>
                </CaseProvider>
            </SystemProvider>
        </UserProvider>
    </BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();